import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Card } from '@/components/ui/card';
import { Building2, Mail, Phone, MapPin } from 'lucide-react';

export const Impressum = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8">
            <div className="w-16 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mb-4"></div>
            <h1
              className="text-4xl md:text-5xl font-bold mb-4"
              style={{ color: 'var(--navy-900)' }}
            >
              Impressum
            </h1>
            <p className="text-lg" style={{ color: 'var(--gray-600)' }}>
              Angaben gemäß § 5 TMG
            </p>
          </div>

          <Card className="glass-card p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6" style={{ color: 'var(--navy-800)' }}>
              Anbieter
            </h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold mb-3" style={{ color: 'var(--navy-700)' }}>
                  Andreas Heinrichs<br />
                  Heinrichs Immobilien
                </h3>
                <p className="text-base" style={{ color: 'var(--gray-700)' }}>
                  RetailInvest by Heinrichs Immobilien
                </p>
              </div>

              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 mt-1" style={{ color: 'var(--gold-600)' }} />
                <div>
                  <p className="font-semibold mb-1" style={{ color: 'var(--navy-700)' }}>Anschrift:</p>
                  <p style={{ color: 'var(--gray-700)' }}>
                    Rindermarkt 8<br />
                    85354 Freising<br />
                    Deutschland
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Mail className="h-5 w-5 mt-1" style={{ color: 'var(--gold-600)' }} />
                <div>
                  <p className="font-semibold mb-1" style={{ color: 'var(--navy-700)' }}>E-Mail:</p>
                  <a href="mailto:info@heinrichsimmobilien.de" className="hover:underline" style={{ color: 'var(--navy-600)' }}>
                    info@heinrichsimmobilien.de
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Phone className="h-5 w-5 mt-1" style={{ color: 'var(--gold-600)' }} />
                <div>
                  <p className="font-semibold mb-1" style={{ color: 'var(--navy-700)' }}>Telefon:</p>
                  <p style={{ color: 'var(--gray-700)' }}>
                    +49 (0) 8161 185 1360
                  </p>
                </div>
              </div>

              <div>
                <p className="font-semibold mb-1" style={{ color: 'var(--navy-700)' }}>Geschäftsführung:</p>
                <p style={{ color: 'var(--gray-700)' }}>
                  Andreas Heinrichs
                </p>
              </div>

              <div>
                <p className="font-semibold mb-1" style={{ color: 'var(--navy-700)' }}>Handelsregister:</p>
                <p className="text-sm italic" style={{ color: 'var(--gray-500)' }}>
                  (Einzelunternehmen - kein Handelsregistereintrag erforderlich)
                </p>
              </div>

              <div>
                <p className="font-semibold mb-1" style={{ color: 'var(--navy-700)' }}>Umsatzsteuer-ID:</p>
                <p style={{ color: 'var(--gray-700)' }}>
                  USt-IdNr.: DE275194139<br />
                  gemäß § 27a Umsatzsteuergesetz
                </p>
              </div>
            </div>
          </Card>

          <Card className="glass-card p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6" style={{ color: 'var(--navy-800)' }}>
              Aufsichtsbehörde
            </h2>
            <p style={{ color: 'var(--gray-700)' }}>
              IHK München<br />
              Max-Joseph-Strasse 2<br />
              80333 München<br />
              <a href="https://www.ihk-muenchen.de" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: 'var(--navy-600)' }}>
                www.ihk-muenchen.de
              </a>
            </p>
          </Card>

          <Card className="glass-card p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6" style={{ color: 'var(--navy-800)' }}>
              Berufsbezeichnung und berufsrechtliche Regelungen
            </h2>
            <p className="mb-4" style={{ color: 'var(--gray-700)' }}>
              <strong>Berufsbezeichnung:</strong> Immobilienmakler (verliehen in Deutschland)
            </p>
            <p className="mb-4" style={{ color: 'var(--gray-700)' }}>
              <strong>Zuständige Kammer:</strong> IHK München<br />
              <strong>Verliehen durch:</strong> Deutschland
            </p>
            <p style={{ color: 'var(--gray-700)' }}>
              Die Gewerbeanmeldung nach § 34c GewO erfolgte am 08.01.2008 durch das Landratsamt Freising.
            </p>
          </Card>

          <Card className="glass-card p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6" style={{ color: 'var(--navy-800)' }}>
              Markeneintragung
            </h2>
            <p style={{ color: 'var(--gray-700)' }}>
              Heinrichs Immobilien ist als Wort/Bildmarke beim Deutschen Patent- und Markenamt (DPMA) registriert:
              <strong className="block mt-2" style={{ color: 'var(--navy-800)' }}>302016023214</strong>
            </p>
          </Card>

          <Card className="glass-card p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6" style={{ color: 'var(--navy-800)' }}>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p style={{ color: 'var(--gray-700)' }}>
              [Name des Verantwortlichen]<br />
              [Anschrift wie oben]
            </p>
          </Card>

          <Card className="glass-card p-8 mb-8">
            <h2 className="text-2xl font-bold mb-6" style={{ color: 'var(--navy-800)' }}>
              Haftungsausschluss
            </h2>
            
            <div className="space-y-4" style={{ color: 'var(--gray-700)' }}>
              <div>
                <h3 className="font-semibold mb-2" style={{ color: 'var(--navy-700)' }}>Haftung für Inhalte</h3>
                <p className="text-sm">
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
                  Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. 
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                  nach den allgemeinen Gesetzen verantwortlich.
                </p>
              </div>

              <div>
                <h3 className="font-semibold mb-2" style={{ color: 'var(--navy-700)' }}>Haftung für Links</h3>
                <p className="text-sm">
                  Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir 
                  keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr 
                  übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder 
                  Betreiber der Seiten verantwortlich.
                </p>
              </div>

              <div>
                <h3 className="font-semibold mb-2" style={{ color: 'var(--navy-700)' }}>Urheberrecht</h3>
                <p className="text-sm">
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                  dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                  der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                  Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
              </div>
            </div>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Impressum;